var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_186375_18308",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30C23.2843 30 30 23.2843 30 15Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_186375_18308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V30H30V0Z",
    fill: "#405059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6724 29.6831L23.3501 8.33663C22.6152 5.38929 19.6302 3.59572 16.6829 4.33057L-4.6636 9.65285C-7.61093 10.3877 -9.40451 13.3727 -8.66965 16.32L-3.34737 37.6666C-2.61252 40.6139 0.372488 42.4075 3.31982 41.6726L24.6663 36.3503C27.6137 35.6155 29.4072 32.6305 28.6724 29.6831Z",
    fill: "#EDD75A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1797 14.625C17.9243 15.2796 19.5819 15.1053 21.1523 14.1024",
    stroke: "black",
    strokeWidth: 0.833333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3303 10.5262C15.2822 10.0685 14.9649 9.72671 14.6216 9.76279C14.2783 9.79888 14.039 10.1992 14.0871 10.6569C14.1352 11.1146 14.4525 11.4564 14.7958 11.4203C15.1391 11.3843 15.3784 10.9839 15.3303 10.5262Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9592 9.83092C21.9111 9.3732 21.5938 9.0314 21.2505 9.06748C20.9072 9.10356 20.6679 9.50386 20.716 9.96158C20.7641 10.4193 21.0814 10.7611 21.4247 10.725C21.768 10.6889 22.0073 10.2886 21.9592 9.83092Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.326f184038e89117137c2205b40c247d.svg";
export { ForwardRef as ReactComponent };